// extracted by css-extract-rspack-plugin
export default {"tds-selector":"tds-selector-BzVRUz","tdsSelector":"tds-selector-BzVRUz"};